<template>
  <div class="container">
    <div class="content">
      <h2>😻 The Furry Tale of Hearts: Purring Together in Life's Catnap🐾</h2>
     <p><strong>🐾 The Cat's Choice: Pouncing Proactively into Partnerships!</strong></p>

      Ah, the mysterious ways of us cats! You see, in the feline world, we have this purr-ticular way of doing things – we choose our humans, not the other way around! Just like a cat carefully selects its favorite lap to curl up on, you too should be proactive and wise in choosing your life partner. It's a bit like our sophisticated cat distribution system, but for your heart!

      <h3>Your Purr-sonal Life: Your relationship </h3>
        <div class="option" @click="selectOption('married')" :class="{ selected: isSelected('married') }">
          <span class="icon">💍</span>
          <b>Married - the government officially has its paws in our relationship</b>
        </div>
        
        <div class="option" @click="selectOption('common-law')" :class="{ selected: isSelected('common-law') }">
          <span class="icon">🤝</span>
          <b>Common-law - we have the same rights as married people with a few nuances</b>
        </div>
        
        <div class="option" @click="selectOption('in-relationship')" :class="{ selected: isSelected('in-relationship') }">
          <span class="icon">♥️</span>
          <b>In a relationship - it's going well apparently</b>
        </div>
        <div class="option" @click="selectOption('dating')" :class="{ selected: isSelected('dating') }">
          <span class="icon">🔍</span>
          <b>Dating - a lot of swiping left and right with a lot of adventures</b>
        </div>
        <div class="option" @click="selectOption('single')" :class="{ selected: isSelected('single') }">
          <span class="icon">🚶‍♂️</span>
          <b>Single and happy about it.  My own hooman's ideal was growing old with lots of cats because we are just amazing!</b>
        </div>
    </div>
      </div>
<br><br><br>
  </template>
  
  <script>
  import { onboardingStore } from '@/components/stores/onboardingStore'; 
  
  export default {
    setup() {
      const store = onboardingStore();
  
      const selectOption = (option) => {
        // Set the selected option directly
        store.updateFormData({ marital_status: option });
      };
  
      // Helper method to check if an option is selected
      const isSelected = (option) => store.formData.marital_status === option;
      
  
      return { store, selectOption, isSelected };
    },
  };
  </script>
<style scoped>
.container {
  background-color: #4A148C; 
 color: black;
 padding: 20px;
 border-radius: 20px;
 display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 300px;
  max-width: 800px; /* Set a maximum width */
  align-items: center; /* Centered alignment */
  margin: auto; /* Center the container on the page */
  margin-top: 0; /* Adjusted as per your requirement */
}

.content {
background-color: white;
padding: 20px;
border-radius: 10px;
color: black;
}

.option {
padding: 10px;
border: 1px solid #ccc;
border-radius: 10px;
text-align: center;
box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
cursor: pointer;
transition: transform 0.3s ease, box-shadow 0.3s ease;
margin-bottom: 10px;
}

.option:hover {
transform: translateY(-5px);
box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}


button {
  grid-column: span 2;
  background-color: #4A148C; /* Dark purple */
  color: white;
  padding: 10px 15px;
  border-radius: 5px;
  border: none;
  cursor: pointer;
  transition: background-color 0.3s;
}

button:hover {
  background-color: black; /* Black background on hover */
}

.selected {
background-color: #4A148C; /* More solid color for selection */
color: white;
}


.icon {
font-size: 24px; /* Larger icon size */
}

/* Additional style if needed */
</style>